import {
  useMutation,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { getCheckoutState } from 'merchant-api/checkout';
import { checkout } from '..';

export interface CompleteCheckoutProps {
  isCompleteLoading: boolean;
  triggerComplete: () => Promise<any>;
  isCompleteError: Error | null;
  completeCheckoutData: unknown;
  mutation: UseMutationResult<any, Error, void>;
}

export function completeCheckout(): CompleteCheckoutProps {
  const queryClient = useQueryClient();
  const { checkoutData } = getCheckoutState();

  const mutation = useMutation({
    mutationFn: async () => {
      const data = await checkout
        .post(`/v1/orchestration/complete/${checkoutData?.checkoutUuid}`)
        .then((res) => res.data);
      // Completion moves the application to FUNDING or CLOSED_WON, so cached applications are stale.
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['checkout'] }),
        queryClient.invalidateQueries({ queryKey: ['app'] }),
        queryClient.invalidateQueries({ queryKey: ['currentApplication'] }),
      ]);
      return data;
    },
    mutationKey: ['completeCheckout', checkoutData?.checkoutUuid],
  });

  return {
    completeCheckoutData: mutation.data,
    isCompleteLoading: mutation.isPending,
    isCompleteError: mutation.error,
    triggerComplete: mutation.mutateAsync,
    mutation,
  };
}

export default completeCheckout;
